import React, { useState, useEffect } from "react";
import {
  get_categories,
  create_product,
  update_product,
} from "../../../redux/actions/adminActions";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import Spinner from "../../reusables/spinner";
import InputField from "../../reusables/input";
import Dropdown from "../../reusables/dropdown";

function AddProduct({
  categories,
  createProduct,
  getCategories,
  accessToken,
  prev,
  prevData,
  updateProduct,
  active,
}) {
  const [selectedCategory, setCategory] = useState("Select a category");
  const [previews, setPreview] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({
    product_name: "",
    product_description: "",
    product_price: "",
    product_image: null,
    product_image_logo: null,
    category_id: "",
    in_stock: "10",
    barcode: "",
    sku: "",
    manufacturer_number: "",
    brand_names: "",
    tags: "",
    unit_weight: "",
    unit_type: "",
    unit_count: "",
    count_type: "",
    item_lenght: "",
    item_lenght_type: "",
    item_width: "",
    item_width_type: "",
    item_height: "",
    item_height_type: "",
    minimum_order: "",
    key_features: "",
    handling_cost_per_unit: null,
    weight_factor: "",
  });

  const weightUnits = [
    "Gram",
    "Decagram",
    "Hectogram",
    "Kilogram",
    "Metric Ton",
  ];
  const lenghtUnits = ["Rod", "Fathom", "Yard", "Foot", "Inch"];
  const lenght_Units = ["Centimeter", "Feet", "Inch", "Inch"];
  const widthUnits = ["Centimeter", "Inch"];

  const handleChange = (e) => {
    if ((e.target.name == 'minimum_order' && isNaN(e.target.value)) || (e.target.name == 'minimum_order' && e.target.value != '' && Number(e.target.value) < 1)) {
      return;
    }
    setData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleLoading = () => {
    setIsLoading(true);

    setTimeout(() => {
      setIsLoading(false);
    }, 4000);
  };

  const handleImageChange = (e) => {
    let reader = new FileReader();
    reader.readAsDataURL(e.target.files[0]);

    reader.onloadend = () => {
      if (e.target.name === "product_image") {
        setData({
          ...formData,
          product_image: e.target.files[0],
        });

        setPreview({
          ...previews,
          product: reader.result,
        });
      } else {
        setData({
          ...formData,
          product_image_logo: e.target.files[0],
        });

        setPreview({
          ...previews,
          logo: reader.result,
        });
      }
    };
  };

  const handleSubmit = (e, status) => {
    e.preventDefault();
    handleLoading();

    if (formData?.category_id !== "") {
      let formdata = new FormData();

      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && value !== "") {
          if (key === "product_image") {
            formdata.append("product_image[]", value);
          } else {
            formdata.append(key, value);
          }
        }
      });

      if (prevData) {
        updateProduct(formData?.id, formdata, accessToken, success, status);
      } else {
        createProduct(formdata, accessToken, status, success);
      }
    } else {
      toast.error("Please provide a category");
    }
  };

  const success = () => {
      console.log('yol')
    prev();
  };

  const handleCategorySelect = (Item) => {
    let category = Item;
    let currentData = formData;
    let updated = {
      ...currentData,
      category_id: category.id,
    };
    setData(updated);
    setCategory(category?.name);
  };

  const handleUnitSelect = (item, name) => {
    let unit = item;
    let currentData = formData;

    let updated = {
      ...currentData,
      [name]: unit,
    };
    setData(updated);
  };

  useEffect(() => {
    if (prevData !== null) {
      setPreview({
        ...previews,
        product: prevData?.product_image[0],
        logo: prevData?.product_image_logo,
      });
      setData(prevData);
      setCategory(prevData?.category?.name);
    } else {
      setData({
        product_name: "",
        product_description: "",
        product_price: "",
        product_image: null,
        product_image_logo: null,
        category_id: "",
        in_stock: "10",
        barcode: "",
        sku: "",
        manufacturer_number: "",
        brand_names: "",
        tags: "",
        unit_weight: "",
        unit_type: "",
        unit_count: "",
        count_type: "",
        item_lenght: "",
        item_lenght_type: "",
        item_width: "",
        item_width_type: "",
        item_height: "",
        item_height_type: "",
        minimum_order: "",
        key_features: "",
        handling_cost_per_unit: null,
        weight_factor: "",
      });
      setCategory("Select a category");
      setPreview({});
    }
    getCategories(accessToken);
  }, [getCategories, accessToken, prevData]);

  return (
    <div>
      <div className="sectionHeight pt-3">
        <h2
          className="sectionText--big textIsBold isClickable alignOnly"
          onClick={prev}
        >
          <i class="ri-arrow-left-line mx-2"></i>
          Add Product
        </h2>

        <p className="sectionText textIsGreen mb-0 pt-2">
          Fields with * are required
        </p>

        <form>
          <div className="row pt-4">
            <div className="col-lg-8">
              <div className="sectionHeight--mid hasBorder product__card hasRadius">
                <div className="bgGray header">
                  <h2 className="sectionText--mid textIsBold">Basic Details</h2>
                </div>

                <div className="container pb-4">
                  <div className="mt-3 mb-3">
                    <InputField
                      label="Product Name*"
                      name="product_name"
                      value={formData?.product_name}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mt-3 mb-3">
                    <InputField
                      label="Product Description*"
                      name="product_description"
                      value={formData?.product_description}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mt-3 mb-3">
                    <InputField
                      type="number"
                      label="Product Standard Price*"
                      name="product_price"
                      value={formData?.product_price}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="">
                    <p className="sectionText--small mt-2 mb-2">
                      Product Image*
                    </p>

                    {formData?.product_image == null ? (
                      <div className="fileUpload center">
                        <input
                          type="file"
                          accept="image/png, image/jpg, image/jpeg"
                          name="product_image"
                          onChange={handleImageChange}
                        />
                        <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                          Tap to upload
                        </p>
                      </div>
                    ) : (
                      <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative">
                        <div className="alignOnly">
                          <div className="hasRadius bgGray imgHolder">
                            <img
                              src={previews.product}
                              className="w-100"
                              alt=""
                            />
                          </div>
                          <h2 className="sectionText--mid mx-3">
                            Product Image*
                          </h2>
                        </div>

                        <div className="fileOptions sectionText">
                          <span className="px-2 hasBorder--right isClickable">
                            <input
                              type="file"
                              style={{
                                width: "fit-content",
                              }}
                              name="product_image"
                              onChange={handleImageChange}
                            />
                            Change
                          </span>
                          <span
                            className="px-2 isClickable"
                            onClick={() =>
                              setData({
                                ...formData,
                                product_image: null,
                              })
                            }
                          >
                            Remove
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pt-3">
                    <p className="sectionText--small mt-2 mb-2">
                      Product Logo image (Dimension 350x210)*
                    </p>

                    {formData?.product_image_logo == null ? (
                      <div className="fileUpload center">
                        <input
                          type="file"
                          accept="image"
                          name="product_image_logo"
                          onChange={handleImageChange}
                        />
                        <p className="mb-0 sectionText--small textIsGreen  textIsBold">
                          Tap to upload
                        </p>
                      </div>
                    ) : (
                      <div className="sectionHeight--short hasBorder hasRadius p-2 fileHolder isRelative">
                        <div className="alignOnly">
                          <div className="hasRadius bgGray imgHolder">
                            <img src={previews.logo} className="w-100" alt="" />
                          </div>
                          <h2 className="sectionText--mid mx-3">
                            Product Logo
                          </h2>
                        </div>

                        <div className="fileOptions sectionText">
                          <span className="px-2 hasBorder--right isClickable">
                            <input
                              type="file"
                              style={{
                                width: "fit-content",
                              }}
                              name="product_image_logo"
                              onChange={handleImageChange}
                            />
                            Change
                          </span>
                          <span
                            className="px-2 isClickable"
                            onClick={() =>
                              setData({
                                ...formData,
                                product_image_logo: null,
                              })
                            }
                          >
                            Remove
                          </span>
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="row pt-3 pb-3">
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Product SKU"
                        name="sku"
                        value={formData?.sku}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="BarCode(UPC)"
                        name="barcode"
                        value={formData?.barcode}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Manufacturer Number"
                        name="manufacturer_number"
                        value={formData?.manufacturer_number}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Brand Names"
                        name="brand_names"
                        value={formData?.brand_names}
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div className="mt-3 mb-3">
                    <InputField
                      label="Tags"
                      name="tags"
                      value={formData?.tags}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="sectionHeight--mid hasBorder product__card hasRadius mt-3">
                <div className="bgGray header">
                  <h2 className="sectionText--mid textIsBold">Measurements</h2>
                </div>

                <div className="container pb-4">
                  <div className="row pt-3 pb-3">
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Unit Weight"
                        name="unit_weight"
                        value={formData?.unit_weight}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <p className="mb-1 textIsBold sectionText--small">
                        Unit Type
                      </p>
                      <Dropdown
                        long
                        value={formData?.unit_type || "Select Unit"}
                      >
                        {weightUnits.map((unit) => (
                          <div
                            className="isClickable hoverGreen"
                            onClick={() => handleUnitSelect(unit, "unit_type")}
                          >
                            <p className="sectionText px-3 py-2 mb-0">{unit}</p>
                          </div>
                        ))}
                      </Dropdown>
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Unit count"
                        name="unit_count"
                        value={formData?.unit_count}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <p className="mb-1 textIsBold sectionText--small">
                        Count Type
                      </p>
                      <Dropdown
                        long
                        value={formData?.count_type || "Select Unit"}
                      >
                        {lenghtUnits.map((unit) => (
                          <div
                            className="isClickable hoverGreen"
                            onClick={() => handleUnitSelect(unit, "count_type")}
                          >
                            <p className="sectionText px-3 py-2 mb-0">{unit}</p>
                          </div>
                        ))}
                      </Dropdown>
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Item Lenght"
                        name="item_lenght"
                        value={formData?.item_lenght}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <p className="mb-1 textIsBold sectionText--small">
                        Item Lenght Type
                      </p>
                      <Dropdown
                        long
                        value={formData?.item_lenght_type || "Select Unit"}
                      >
                        {lenght_Units.map((unit) => (
                          <div
                            className="isClickable hoverGreen"
                            onClick={() =>
                              handleUnitSelect(unit, "item_lenght_type")
                            }
                          >
                            <p className="sectionText px-3 py-2 mb-0">{unit}</p>
                          </div>
                        ))}
                      </Dropdown>
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Item Width"
                        name="item_width"
                        value={formData?.item_width}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <p className="mb-1 textIsBold sectionText--small">
                        Item Width Type
                      </p>
                      <Dropdown
                        long
                        value={formData?.item_width_type || "Select Unit"}
                      >
                        {widthUnits.map((unit) => (
                          <div
                            className="isClickable hoverGreen"
                            onClick={() =>
                              handleUnitSelect(unit, "item_width_type")
                            }
                          >
                            <p className="sectionText px-3 py-2 mb-0">{unit}</p>
                          </div>
                        ))}
                      </Dropdown>
                    </div>
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Item Height"
                        name="item_height"
                        value={formData?.item_height}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-lg-6 pt-3">
                      <p className="mb-1 textIsBold sectionText--small">
                        Item Height Type
                      </p>
                      <Dropdown
                        long
                        value={formData?.item_height_type || "Select Unit"}
                      >
                        {widthUnits.map((unit) => (
                          <div
                            className="isClickable hoverGreen"
                            onClick={() =>
                              handleUnitSelect(unit, "item_height_type")
                            }
                          >
                            <p className="sectionText px-3 py-2 mb-0">{unit}</p>
                          </div>
                        ))}
                      </Dropdown>
                    </div>
                  </div>

                  <div className="mt-3 mb-3">
                    <InputField
                      label="Minimum Order*"
                      name="minimum_order"
                      value={formData?.minimum_order}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mt-3 mb-3">
                    <InputField
                      label="Key Features"
                      name="key_features"
                      value={formData?.key_features}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="row pb-3">
                    {/* <div className="col-lg-6 pt-3">
                                            <InputField
                                                type='number'
                                                label="Handling Cost*"
                                                name='handling_cost_per_unit'
                                                value={ formData?.handling_cost_per_unit }
                                                onChange={ handleChange } />
                                        </div> */}
                    <div className="col-lg-6 pt-3">
                      <InputField
                        label="Weight Factor"
                        name="weight_factor"
                        value={formData?.weight_factor}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="alignRight mt-4">
                {isLoading ? (
                  <button
                    className="btn__filled textIsBold center mx-2 w-100"
                    disabled
                  >
                    Please Wait {""}
                    <Spinner />
                  </button>
                ) : (
                  <>
                    {" "}
                    {!active && (
                      <button
                        className="btn__transparent w-100 mt-2 mb-2"
                        onClick={(e) => handleSubmit(e, "save")}
                      >
                        Save
                      </button>
                    )}
                    <button
                      className="btn__filled hasRadius w-100 my-2 mx-2"
                      onClick={(e) => handleSubmit(e, "publish")}
                    >
                      Save & Publish
                    </button>{" "}
                  </>
                )}
              </div>
            </div>

            <div className="col-lg-4 mt-3">
              <div className="product__card hasBorder hasRadius">
                <div className="header bgGray">
                  <h2 className="sectionText">Product Attributes</h2>
                </div>

                <div className="sectionHeight--mid alignOnly container">
                  <div className="w-100 py-3">
                    <Dropdown label="Category*" value={selectedCategory}>
                      {categories?.map((item) => (
                        <div
                          className="isClickable hoverGreen"
                          onClick={() => handleCategorySelect(item)}
                        >
                          <p className="sectionText px-3 py-2 mb-0">
                            {item.name}
                          </p>
                        </div>
                      ))}
                    </Dropdown>

                    <div className="pt-3 pb-3">
                      {isLoading ? (
                        <button
                          className="btn__filled textIsBold center mx-2 w-100"
                          disabled
                        >
                          Please Wait {""}
                          <Spinner />
                        </button>
                      ) : (
                        <>
                          {" "}
                          {!active && (
                            <button
                              className="btn__transparent w-100 mt-2 mb-2"
                              onClick={(e) => handleSubmit(e, "save")}
                            >
                              Save
                            </button>
                          )}
                          <button
                            className="btn__filled hasRadius w-100 my-2 mx-2"
                            onClick={(e) => handleSubmit(e, "publish")}
                          >
                            Save & Publish
                          </button>{" "}
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
}

const mapStateToProps = (state) => ({
  categories: state.admin.categories,
  accessToken: state.admin.token,
});

const mapDispatchToProps = (dispatch) => ({
  getCategories: (token) => dispatch(get_categories(token)),
  createProduct: (data, token, staus, success) =>
    dispatch(create_product(data, token, staus, success)),
  updateProduct: (id, data, token, success, status) =>
    dispatch(update_product(id, data, token, success, status)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AddProduct);
